import { render, staticRenderFns } from "./OverviewCalendar.vue?vue&type=template&id=23d7a35f"
import script from "./OverviewCalendar.vue?vue&type=script&lang=js"
export * from "./OverviewCalendar.vue?vue&type=script&lang=js"
import style0 from "./OverviewCalendar.vue?vue&type=style&index=0&id=23d7a35f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports